/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Kit 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Navbar.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `name` key is used for the name of the route on the Navbar.
  2. The `icon` key is used for the icon of the route on the Navbar.
  3. The `collapse` key is used for making a collapsible item on the Navbar that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  4. The `route` key is used to store the route location which is used for the react router.
  5. The `href` key is used to store the external links location.
  6. The `component` key is used to store the component of its route.
  7. The `dropdown` key is used to define that the item should open a dropdown for its collapse items .
  8. The `description` key is used to define the description of
          a route under its name.
  9. The `columns` key is used to define that how the content should look inside the dropdown menu as columns,
          you can set the columns amount based on this key.
  10. The `rowsPerColumn` key is used to define that how many rows should be in a column.
*/

// @mui material components
import Icon from "@mui/material/Icon";

// @mui icons
//import GitHubIcon from "@mui/icons-material/GitHub";
import InfoIcon from "@mui/icons-material/Info";
import FolderIcon from "@mui/icons-material/Folder";

// Pages
import AboutUs from "layouts/pages/landing-pages/about-us";
//import ContactUs from "layouts/pages/landing-pages/contact-us";
import GetOnTheVotersList from "pages/LandingPages/GetOnTheVotersList";
import RegisteredParties from "pages/LandingPages/RegisteredParties";
// import CandidateAndPartySpendingAndReimbursements from "pages/LandingPages/CandidateAndPartySpendingAndReimbursements";
import ElectionAdvertisingCampaignSignageAndThirdPartyAdvertising from "pages/LandingPages/ElectionAdvertisingCampaignSignageAndThirdPartyAdvertising";
import ElectoralFinanceCandidateReportingRequirements from "pages/LandingPages/ElectoralFinanceCandidateReportingRequirements";
import Resources from "pages/LandingPages/Resources";
import LegislationAndRegulation from "pages/LandingPages/LegislationAndRegulation";
import TariffOfFees from "pages/LandingPages/TariffOfFees";
import AnnualAndOtherReports from "pages/LandingPages/AnnualAndOtherReports";
import ElectoralFinanceReports from "pages/LandingPages/ElectoralFinanceReports";
import CandidatesAndOfficialAgents from "pages/LandingPages/CandidatesAndOfficialAgents";
import ElectoralDistrictMap from "pages/LandingPages/ElectoralDistrictMap";
import Compliance from "pages/LandingPages/Compliance";
import ENSExecutiveExpenses from "pages/LandingPages/ENSExecutiveExpenses";
import ElectoralDistrictAssociations from "pages/LandingPages/ElectoralDistrictAssociations";
import PoliciesAndCirculars from "pages/LandingPages/PoliciesAndCirculars";
import Employment from "pages/LandingPages/Employment";
import CandidatesFormsAndHandbooks from "pages/LandingPages/CandidatesFormsAndHandbooks";
import EDAsFormsAndHandbooks from "pages/LandingPages/EDAsFormsAndHandbooks";
import ThirdPartiesFormsAndHandbooks from "pages/LandingPages/ThirdPartiesFormsAndHandbooks";
import PartiesFormsAndHandbooks from "pages/LandingPages/PartiesFormsAndHandbooks";
import ForElectionWorkers from "./pages/LandingPages/ForElectionWorkers";
//import Author from "layouts/pages/landing-pages/author";
// import SignIn from "layouts/pages/authentication/sign-in";

// Sections
// import PageHeaders from "layouts/sections/page-sections/page-headers";
// import Features from "layouts/sections/page-sections/featuers";
// import Navbars from "layouts/sections/navigation/navbars";
// import NavTabs from "layouts/sections/navigation/nav-tabs";
// import Pagination from "layouts/sections/navigation/pagination";
// import Inputs from "layouts/sections/input-areas/inputs";
// import Forms from "layouts/sections/input-areas/forms";
// import Alerts from "layouts/sections/attention-catchers/alerts";
// import Modals from "layouts/sections/attention-catchers/modals";
// import TooltipsPopovers from "layouts/sections/attention-catchers/tooltips-popovers";
// import Avatars from "layouts/sections/elements/avatars";
// import Badges from "layouts/sections/elements/badges";
// import BreadcrumbsEl from "layouts/sections/elements/breadcrumbs";
// import Buttons from "layouts/sections/elements/buttons";
// import Dropdowns from "layouts/sections/elements/dropdowns";
// import ProgressBars from "layouts/sections/elements/progress-bars";
// import Toggles from "layouts/sections/elements/toggles";
// import Typography from "layouts/sections/elements/typography";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
import PeopleIcon from "@mui/icons-material/People";

const routes = [
  {
    name: "For Voters",
    icon: <HowToVoteIcon />,
    route: "/voters",
    component: <GetOnTheVotersList />,
  },
  {
    name: "Candidates, Parties, EDA's",
    icon: <PeopleIcon />,
    collapse: [
      {
        name: "Registered Parties",
        //description: "All about overview, quick start, license and contents",
        //href: "https://www.creative-tim.com/learning-lab/react/quick-start/material-kit/",
        route: "/registered-parties",
        component: <RegisteredParties />
      },
      // {
      //   name: "Candidate And Party Spending And Reimbursements",
      //   //description: "All about overview, quick start, license and contents",
      //   //href: "https://www.creative-tim.com/learning-lab/react/quick-start/material-kit/",
      //   route: "/CandidateAndParty-SpendingAndReimbursements",
      //   component: <CandidateAndPartySpendingAndReimbursements />
      // },
      {
        name: "Electoral Finance Candidate Reporting Requirements",
        //description: "All about overview, quick start, license and contents",
        //href: "https://www.creative-tim.com/learning-lab/react/quick-start/material-kit/",
        route: "/ElectoralFinanceCandidateReportingRequirements",
        component: <ElectoralFinanceCandidateReportingRequirements />
      },
      {
        name: "Election Advertising, Campaign Signage, and Third-Party Advertising",
        //description: "All about overview, quick start, license and contents",
        //href: "https://www.creative-tim.com/learning-lab/react/quick-start/material-kit/",
        route: "/ElectionAdvertisingCampaignSignageAndThirdPartyAdvertising",
        component: <ElectionAdvertisingCampaignSignageAndThirdPartyAdvertising />
      },
      {
        name: "Candidates And Official Agents",
        //description: "All about overview, quick start, license and contents",
        //href: "https://www.creative-tim.com/learning-lab/react/quick-start/material-kit/",
        route: "/CandidatesAndOfficialAgents",
        component: <CandidatesAndOfficialAgents />
      },
      {
        name: "Electoral District Associations",
        route: "/Electoral-District-Associations",
        component: <ElectoralDistrictAssociations />
      },
      {
        name: "Forms & Handbooks",
        //route: "/legislation-and-regulation",
        //component: <LegislationAndRegulation />,
        dropdown: true,
        collapse: [
          {
            name: "Forms and Handbooks for Parties",
            route: "/PartiesFormsAndHandbooks",
            component: <PartiesFormsAndHandbooks />,
          },
          {
            name: "Forms and Handbooks for Candidates",
            route: "/CandidatesFormsAndHandbooks",
            component: <CandidatesFormsAndHandbooks />,
          },
          {
            name: "Forms and Handbooks for Electoral District Associations (EDAs)",
            route: "/EDAsFormsAndHandbooks",
            component: <EDAsFormsAndHandbooks />,
          },
          {
            name: "Forms and Handbooks for Third Parties",
            route: "/ThirdPartiesFormsAndHandbooks",
            component: <ThirdPartiesFormsAndHandbooks />,
          },
        ],
      },
      // {
      //   name: "foundation",
      //   description: "See our colors, icons and typography",
      //   href: "https://www.creative-tim.com/learning-lab/react/colors/material-kit/",
      // },
      // {
      //   name: "components",
      //   description: "Explore our collection of fully designed components",
      //   href: "https://www.creative-tim.com/learning-lab/react/alerts/material-kit/",
      // },
      // {
      //   name: "plugins",
      //   description: "Check how you can integrate our plugins",
      //   href: "https://www.creative-tim.com/learning-lab/react/datepicker/material-kit/",
      // },
    ],
  },
  // {
  //   name: "Candidates, Parties, EDA's",
  //   icon: <PeopleIcon />,
  //   route: "/contact-us",
  //   component: <ContactUs />,
  // },
  {
    name: "Elections Act",
    icon: <Icon>dashboard</Icon>,
    href: "https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf",
  },
  // {
  //   name: "pages",
  //   icon: <Icon>dashboard</Icon>,
  //   columns: 1,
  //   rowsPerColumn: 2,
  //   collapse: [
  //     {
  //       name: "landing pages",
  //       collapse: [
  //         {
  //           name: "For Voters",
  //           route: "/pages/landing-pages/about-us",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "Candidates, Parties, EDA's",
  //           route: "/pages/landing-pages/contact-us",
  //           component: <ContactUs />,
  //         },
  //         {
  //           name: "author",
  //           route: "/pages/landing-pages/author",
  //           component: <Author />,
  //         },
  //       ],
  //     },
  //     // {
  //     //   name: "account",
  //     //   collapse: [
  //     //     {
  //     //       name: "sign in",
  //     //       route: "/pages/authentication/sign-in",
  //     //       component: <SignIn />,
  //     //     },
  //     //   ],
  //     // },
  //   ],
  // },
  // {
  //   name: "sections",
  //   icon: <Icon>view_day</Icon>,
  //   collapse: [
  //     {
  //       name: "page sections",
  //       description: "See all sections",
  //       dropdown: true,
  //       collapse: [
  //         {
  //           name: "page headers",
  //           route: "/sections/page-sections/page-headers",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "features",
  //           route: "/sections/page-sections/features",
  //           component: <AboutUs />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "navigation",
  //       description: "See all navigations",
  //       dropdown: true,
  //       collapse: [
  //         {
  //           name: "navbars",
  //           route: "/sections/navigation/navbars",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "nav tabs",
  //           route: "/sections/navigation/nav-tabs",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "pagination",
  //           route: "/sections/navigation/pagination",
  //           component: <AboutUs />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "input areas",
  //       description: "See all input areas",
  //       dropdown: true,
  //       collapse: [
  //         {
  //           name: "inputs",
  //           route: "/sections/input-areas/inputs",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "forms",
  //           route: "/sections/input-areas/forms",
  //           component: <AboutUs />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "attention catchers",
  //       description: "See all examples",
  //       dropdown: true,
  //       collapse: [
  //         {
  //           name: "alerts",
  //           route: "/sections/attention-catchers/alerts",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "modals",
  //           route: "/sections/attention-catchers/modals",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "tooltips & popovers",
  //           route: "/sections/attention-catchers/tooltips-popovers",
  //           component: <AboutUs />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "elements",
  //       description: "See all 32 examples",
  //       dropdown: true,
  //       collapse: [
  //         {
  //           name: "avatars",
  //           route: "/sections/elements/avatars",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "badges",
  //           route: "/sections/elements/badges",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "breadcrumbs",
  //           route: "/sections/elements/breadcrumbs",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "buttons",
  //           route: "/sections/elements/buttons",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "dropdowns",
  //           route: "/sections/elements/dropdowns",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "progress bars",
  //           route: "/sections/elements/progress-bars",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "toggles",
  //           route: "/sections/elements/toggles",
  //           component: <AboutUs />,
  //         },
  //         {
  //           name: "typography",
  //           route: "/sections/elements/typography",
  //           component: <AboutUs />,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   name: "docs",
  //   icon: <Icon>article</Icon>,
  //   collapse: [
  //     {
  //       name: "Elections Act",
  //       description: "All about overview, quick start, license and contents",
  //       href: "https://www.creative-tim.com/learning-lab/react/quick-start/material-kit/",
  //     },
  //     // {
  //     //   name: "foundation",
  //     //   description: "See our colors, icons and typography",
  //     //   href: "https://www.creative-tim.com/learning-lab/react/colors/material-kit/",
  //     // },
  //     // {
  //     //   name: "components",
  //     //   description: "Explore our collection of fully designed components",
  //     //   href: "https://www.creative-tim.com/learning-lab/react/alerts/material-kit/",
  //     // },
  //     // {
  //     //   name: "plugins",
  //     //   description: "Check how you can integrate our plugins",
  //     //   href: "https://www.creative-tim.com/learning-lab/react/datepicker/material-kit/",
  //     // },
  //   ],
  // },

  {
    name: "Resources",
    icon: <FolderIcon />,
    collapse: [
      {
        name: "Past Election Results",
        route: "/past-election-results",
        component: <Resources />
      },
      {
        name: "Annual Reports/ Other Reports",
        route: "/AnnualAndOtherReports",
        component: <AnnualAndOtherReports />
      },
      {
        name: "Electoral Finance Reports",
        route: "/ElectoralFinanceReports",
        component: <ElectoralFinanceReports />
      },
      {
        name: "Electoral District Map/information",
        route: "/Electoral-District-Map",
        component: <ElectoralDistrictMap />
      },
      // {
      //   name: "Electoral District Information",
      //   //route: "/legislation-and-regulation",
      //   //component: <LegislationAndRegulation />,
      //   dropdown: true,
      //   collapse: [
      //     {
      //       name: "Electoral District Map",
      //       route: "/Electoral-District-Map",
      //       component: <ElectoralDistrictMap />,
      //     },
      //     {
      //       name: "Electoral District Profiles",
      //       href: "https://electionsns.maps.arcgis.com/apps/dashboards/2c7c602a6a8f4837ae80f362e0fd2a55",
      //     },
      //   ],
      // },
      {
        name: "Legislation & Regulation",
        //route: "/legislation-and-regulation",
        //component: <LegislationAndRegulation />,
        dropdown: true,
        collapse: [
          {
            name: "Legislation",
            route: "/legislation-and-regulation",
            component: <LegislationAndRegulation />,
          },
          {
            name: "Tariff of Fees",
            route: "/Tariff-of-Fees",
            component: <TariffOfFees />,
          },
        ],
      },
      {
        name: "Policies And Circulars",
        route: "/Policies-And-Circulars",
        component: <PoliciesAndCirculars />
      },
      {
        name: "Compliance",
        route: "/compliance",
        component: <Compliance />
      },
      {
        name: "For Election Workers",
        route: "/ForElectionWorkers",
        component: <ForElectionWorkers />
      },
      // {
      //   name: "Annual Reports/ Other Reports",
      //   route: "/AnnualAndOtherReports",
      //   component: <AnnualAndOtherReports />
      // },
      // {
      //   name: "Legislation & Regulation",
      //   route: "/ElectoralFinanceCandidateReportingRequirements",
      //   component: <ElectoralFinanceCandidateReportingRequirements />
      // },
    ],
  },

  // {
  //   name: "Resources",
  //   icon: <FolderIcon />,
  //   route: "/resources",
  //   component: <Resources />,
  // },
  {
    name: "About Us",
    icon: <InfoIcon />,
    // route: "/about-us",
    // component: <AboutUs />,
    dropdown: true,
        collapse: [
          {
            name: "About ENS",
            route: "/about-us",
            component: <AboutUs />,
          },
          {
            name: "ENS Executive Expenses",
            route: "/executive-expenses",
            component: <ENSExecutiveExpenses />,
          },
          {
            name: "Employment",
            route: "/employment",
            component: <Employment />,
          },
        ],
  },
];

export default routes;
